// Import from NPM
// -------------------------------------
import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

// Import Reducer Routes
// -------------------------------------
import { AuthenticationReducer } from "appRedux/Authentication.reducer.react";
import { ArticleAttemptReducer } from "appRedux/ArticleAttempt.reducer.react";
import { BlogReducer } from "appRedux/Blog.reducer.react";
import { SessionReducer } from "appRedux/Session.reducer.react";
import { TrackerReducer } from "../../tracker/redux/Tracker.reducer.react";

let RootReducer = combineReducers({
    auth: AuthenticationReducer,
    routing: routerReducer,
    articleAttempt: ArticleAttemptReducer,
    blog: BlogReducer,
    session: SessionReducer,
    trackers: TrackerReducer
});

export { RootReducer };
